import React from 'react';
import './InstructionModal.css';

export default function InstructionModal({ onClose }) {
  return (
    <div className="instr-overlay">
      <div className="instr-box">
        <ul>
          <li>Press and hold a node to unfold its entire group.</li>
          <li>Click any node to toggle focus on that group.</li>
          <li>Use the control panel at the bottom-right to change the viewing property.</li>
        </ul>
        <hr style={{ margin: '1em 0', border: 'none', borderTop: '1px solid #ccc' }} />
        <p style={{ fontSize: '0.85em' }}>
          GitHub:{' '}
          <a
            href="https://github.com/C171017/Social-Network-Columbia-Barnard"
            target="_blank"
            rel="noopener noreferrer"
          >
            C171017/Social-Network-Columbia-Barnard
          </a>
          <br />
          Contact: <a href="mailto:c171017howie@gmail.com">c171017howie@gmail.com</a>
        </p>
        <button className="instr-close" onClick={onClose}>
          Got it!
        </button>
      </div>
    </div>
  );
}
